// extracted by mini-css-extract-plugin
export default {"pageNotFound":"PageNotFound_pageNotFound__tE4i8","icon":"PageNotFound_icon__8nvtZ","links":"PageNotFound_links__tEF0S"};